import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  FaRobot,
  FaFileSignature,
  FaFileContract,
  FaComments,
  FaBrain,
  FaSearch,
} from "react-icons/fa";

function AISection() {
  const navigate = useNavigate();

  const tools = [
    {
      id: "analyzer",
      icon: <FaSearch className="text-3xl text-yellow-400" />,
      title: "تحليل العقود تلقائيًا",
      desc: "يحلل الذكاء الاصطناعي العقد ويكشف الثغرات والمخاطر القانونية بدقة عالية.",
    },
    {
      id: "draft",
      icon: <FaFileSignature className="text-3xl text-yellow-400" />,
      title: "توليد البنود والصياغات",
      desc: "اكتب الفكرة وسيقوم النظام بصياغتها قانونيًا باحتراف وفقًا للقانون المصري.",
    },
    {
      id: "advisor",
      icon: <FaComments className="text-3xl text-yellow-400" />,
      title: "المستشار القانوني الذكي",
      desc: "اكتب سؤالك القانوني واحصل على إجابة فورية ومبنية على نصوص القوانين.",
    },
    {
      id: "summarizer",
      icon: <FaBrain className="text-3xl text-yellow-400" />,
      title: "ملخص القضايا والمذكرات",
      desc: "يلخص المذكرات القانونية بدقة ويستخرج النقاط الجوهرية والعناصر القانونية.",
    },
    {
      id: "smartContracts",
      icon: <FaFileContract className="text-3xl text-yellow-400" />,
      title: "توليد العقود الذكية",
      desc: "أنشئ عقدًا كاملًا من وصف بسيط خلال ثوانٍ، بصياغة دقيقة ومطابقة للقانون.",
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="bg-gradient-to-br from-gray-900 via-gray-950 to-black border border-yellow-400/20 rounded-2xl shadow-2xl p-6 text-white backdrop-blur-lg relative overflow-hidden"
    >
      {/* ✨ خلفية تأثيرية خفيفة */}
      <div className="absolute inset-0 bg-gradient-to-t from-yellow-600/5 via-transparent to-transparent pointer-events-none"></div>

      {/* العنوان */}
      <div className="flex items-center gap-3 mb-6">
        <motion.div
          initial={{ rotate: -10, scale: 0.8 }}
          animate={{ rotate: 0, scale: 1 }}
          transition={{ type: "spring", stiffness: 120 }}
        >
          <FaRobot className="text-yellow-400 text-4xl drop-shadow-lg" />
        </motion.div>
        <h2 className="text-2xl md:text-3xl font-extrabold text-yellow-400 drop-shadow-sm">
          قسم الذكاء الاصطناعي
        </h2>
      </div>

      <p className="text-gray-300 mb-8 leading-relaxed text-sm md:text-base">
        استخدم أدوات الذكاء الاصطناعي القانوني لتحليل العقود، توليد الصياغات، وتقديم
        الاستشارات بشكل احترافي ودقيق.
      </p>

      {/* البطاقات */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {tools.map((tool, index) => (
          <motion.div
            key={tool.id}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{
              scale: 1.05,
              boxShadow: "0 0 20px rgba(250, 204, 21, 0.25)",
            }}
            whileTap={{ scale: 0.98 }}
            onClick={() => navigate(`/ai/${tool.id}`)}
            className="cursor-pointer bg-gradient-to-br from-yellow-500/10 to-yellow-600/5 hover:from-yellow-500/15 hover:to-yellow-600/10 border border-yellow-400/30 rounded-xl p-5 transition-all duration-300 flex items-start gap-4 hover:border-yellow-400/60"
          >
            <div className="text-yellow-400 mt-1">{tool.icon}</div>
            <div className="flex flex-col">
              <h3 className="font-bold text-lg text-yellow-300 mb-1">
                {tool.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                {tool.desc}
              </p>
            </div>
          </motion.div>
        ))}
      </div>

      {/* الفوتر الصغير */}
      <div className="text-center text-gray-500 text-xs mt-8 border-t border-yellow-500/10 pt-3">
        ⚖️ جميع الأدوات تعمل بالذكاء الاصطناعي المصري — بإشراف "الأفوكاتو الذكي".
      </div>
    </motion.div>
  );
}

export default AISection;
